// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import store from './store'; // 引入 Vuex store
import zhCn from 'element-plus/es/locale/lang/zh-cn'; 
import 'element-plus/dist/index.css';

const app = createApp(App);
app.use(router);
app.use(store);
app.use(ElementPlus, { locale: zhCn });
app.mount('#app');
